import * as React from "react";
import { IInfiniteLoadingProps } from "./infinite-interface";
import { result } from "./infinite-utils/infinite-utils-result";
import { Item } from "./item";

export class InfiniteLoading extends React.PureComponent<IInfiniteLoadingProps, any> {
    UNSAFE_componentWillMount() {
        this.props.api.on("afterRenderCells", this.handleAfterRenderCells);
    }

    componentWillUnmount() {
        this.props.api.off("afterRenderCells", this.handleAfterRenderCells);
    }

    render() {
        return null;
    }

    private handleAfterRenderCells = ({
        cursor,
        scrollTop,
        containerHeight,
        onGetCellDisplayInfo,
        containerWidth,
        childrenToDisplay,
        cellRenderer,
    }) => {
        const { onLoadMore, isFetching, hasMoreResults } = this.props;
        if (onLoadMore && hasMoreResults && !isFetching && scrollTop + containerHeight + 120 > cursor.top) {
            onLoadMore();
        }

        if (isFetching) {
            for (let i = 0; i < 10; i++) {
                const dimensions = result(onGetCellDisplayInfo, { index: i, tombstone: true });

                if (dimensions.width) {
                    if (cursor.left + dimensions.width > containerWidth) {
                        cursor.left = 0;
                        cursor.top = cursor.top + dimensions.height;
                    }
                }

                if (cursor.top + dimensions.height >= scrollTop) {
                    childrenToDisplay.push(
                        this.renderTombstone({
                            position: {
                                top: cursor.top,
                                left: cursor.left,
                            },
                            key: `tombstone-${i}`,
                            cellRenderer,
                        }),
                    );
                }

                if (dimensions.width) {
                    cursor.left = cursor.left + dimensions.width;
                    if (i === 9) {
                        cursor.left = 0;
                        cursor.top = cursor.top + dimensions.height;
                    }
                } else {
                    cursor.top = cursor.top + dimensions.height;
                }
            }
        }
    };

    private renderTombstone = ({
        position: { top, left },
        dataIndex = -1,
        zIndex = 1,
        display = "block",
        cellRenderer,
        key,
    }) => {
        const style: React.CSSProperties = {
            position: "absolute",
            WebkitTransform: `translate3d(${left}px, ${top}px, 0px)`,
            transform: `translate3d(${left}px, ${top}px, 0px)`,
            zIndex,
            display,
        };

        const children = cellRenderer({
            dataIndex,
            tombstone: true,
        });

        return (
            <Item key={key} style={style} className="infiniteCell tombtone">
                {children}
            </Item>
        );
    };
}
